/**
 * Copyright (c) 2010-2021 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */

/// <reference lib="webworker" />

import { expose } from 'comlink';
import { FetchWorker } from './fetch-worker.class';

expose(FetchWorker);
